module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "front_"
  }, [_vm._v("Front Cover: A Cassini image of Saturn’s moon Mimas with the outer part of the planet’s A ring and the narrow F ring in the background. Mimas is one of many moons that gravitationally interact with the rings to produce wave structures. See the article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Cassini-Huygens Mission to the Saturn System")]), _vm._v(" for a summary of results from this mission. (NASA/JPL-Caltech/Space Science Institute)")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68e3c76a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Front.vue
// module id = 60
// module chunks = 0